import React, { useEffect, useState } from 'react';

import {permissionService} from '../../services';
import messages from './messages.json';

// IMPORTANT: do not define a component class inside Can's render path —
// React treats every new class identity as a different component type
// and unmounts/remounts the entire subtree on every parent re-render.
// That regression (NotificationContext re-fetching campaigns + messages
// on every Edit click / modal close) was the symptom that surfaced this.
const Can = ({role, perform, data, yes, no, isTest}) => {
  const [authorized, setAuthorized] = useState(null);

  useEffect(() => {
    let cancelled = false;

    permissionService
      .authorized(role, perform, data)
      .then((result) => { if (!cancelled) setAuthorized(result); });

    return () => { cancelled = true; };
  }, [role, perform, data]);

  if (isTest) return yes();

  if (authorized === null) return (<div>{messages.ink.auth.loading}</div>);

  return authorized ? yes() : no();
};

export default Can;
